/**
 * Whether a code rule's saved draft is exactly what its active version froze —
 * the one answer the rules list and the rule page both give, so the two cannot
 * disagree about "unapplied changes".
 *
 * A draft with no saved source has nothing of its own to apply. Otherwise only
 * two equal fingerprints prove a match: a missing one (a row written before
 * fingerprints and not yet backfilled) cannot, so it reads as unapplied — the
 * state that still offers Apply and Discard — rather than as a clean rule.
 */
export const agenticLogicDraftMatchesVersion = ({
  draft,
  versionFingerprint,
}: {
  draft: { hasSource: boolean; contentFingerprint: string | null } | null;
  versionFingerprint: string | null;
}): boolean => {
  if (draft === null || !draft.hasSource) {
    return true;
  }
  return (
    draft.contentFingerprint !== null &&
    versionFingerprint !== null &&
    draft.contentFingerprint === versionFingerprint
  );
};
